import { useState } from 'react';
import { Modal } from '@bb/ui';
import type { FilterCatalog, FilterCatalogEntry } from '../../api/client.ts';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  catalog: FilterCatalog;
  onPick: (entry: FilterCatalogEntry) => void;
}

/** Filter picker (BB-41): the catalogue by category with a search over names, as in the Braze filter picker. */
export function FilterPicker({ open, onOpenChange, catalog, onPick }: Props) {
  const [query, setQuery] = useState('');
  const q = query.trim().toLowerCase();
  const visible = catalog.types.filter((t) => !q || t.label.en.toLowerCase().includes(q) || t.label.uk.toLowerCase().includes(q) || t.type.includes(q));
  return (
    <Modal open={open} onOpenChange={onOpenChange} title="Add a filter">
      <label>
        Search <input aria-label="Search filters" value={query} onChange={(e) => setQuery(e.target.value)} autoFocus />
      </label>
      {visible.length === 0 && <p className="hint">No filter matches “{query}”.</p>}
      {catalog.categories.map((category) => {
        const items = visible.filter((t) => t.category === category.key);
        if (items.length === 0) return null;
        return (
          <section key={category.key} aria-label={category.label.en}>
            <h4>{category.label.en}</h4>
            <ul className="filter-picker__list">
              {items.map((t) => (
                <li key={t.type}>
                  <button
                    type="button"
                    className="link-button"
                    onClick={() => {
                      onPick(t);
                      onOpenChange(false);
                    }}
                  >
                    {t.label.en}
                  </button>
                </li>
              ))}
            </ul>
          </section>
        );
      })}
    </Modal>
  );
}
